import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-carro-por-que {
  background: #F5F9FB;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 {
  padding-top: 32px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .ctn-home-24 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .ctn-home-24 img {
  width: 160px;
  margin: 23.6px 20px 23.95px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .por-que-textos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .por-que-titulo {
  margin: 0;
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .por-que-subtitulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .por-que-subtitulo b {
  font-weight: 800;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p2 {
  padding: 32px 0 24px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p2 .custom-carousel .embla__container {
  max-width: 1091px;
  /* margin: auto; */
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p2 .slide {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 199px;
  padding: 56px 0px 17px 0px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--black-cccccc, #CCC);
  background: var(--Red-Red-Boston-01, #C00);
  margin-right: 24px;
  flex: 0 0 199px;
}

#emp-garantia-carro-por-que .emp-garantia-carro-por-que-p2 .slide .slide-texo {
  color: #FFF;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#emp-garantia-carro-por-que .home-pagination {
  margin-top: 32px;
}

#emp-garantia-carro-por-que .home-pagination .embla__prev.enable-mobile-arrows, 
#emp-garantia-carro-por-que .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#emp-garantia-carro-por-que .btn-por-que-simular {
  width: 100%;
  max-width: 272px;
  height: 48px;
  margin: 32px auto 0;
}


@media (min-width: 992px) {
  #emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 {
    padding-top: 56px;
  }
  
  #emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .ctn-home-24 {
    display: flex;
    flex-direction: row-reverse;
  }
  
  #emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .ctn-home-24 img {
    width: 240px;
    margin: 35.4px 30px 35.95px;
  }

  #emp-garantia-carro-por-que .emp-garantia-carro-por-que-p1 .por-que-titulo {
    font-size: 40px;
    line-height: 60px;
    max-width: 710px;
  }

  #emp-garantia-carro-por-que .emp-garantia-carro-por-que-p2 {
    padding: 40px 0 80px;
  }
  
  #emp-garantia-carro-por-que .home-pagination {
    margin-top: 48px;
  }
  
  #emp-garantia-carro-por-que .btn-por-que-simular {
    margin: 48px auto 0;
  }
}

@media (min-width: 1180px) {
  #emp-garantia-carro-por-que .home-pagination {
    display: none;
  }
}`;

export default styles;